import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { HostedpaymentDialogComponent } from '../model/hostedpayment-dialog/hostedpayment-dialog.component';
import { NotificationService } from './notification.service';
import { RestApiService } from './restapi.service';
import { UserService } from './user.service';
import { UniquePipe } from '../pipes/Unique.pipe';
import * as moment from 'moment';
import { UtilityService } from './utility.service';
import { CompanyService } from './company.service';
import { ConfigService } from './config.service';
import { EWALLET_MERCHANT_ID } from 'src/app/constant';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {
    public PaymentDataResponse: any = {};
    public PaymentTypeResponse: Array<any> = [];
    public selectedPaymentTypeName = '';
    public SelectedPaymentTypes: any = {};
    public OldSelectedPaymentType: any = {};
    public oldSelectedPaymentTypeName: string = '';
    public AllowedMethods = [];
    public SaveMethods = [];
    public IsFrameReload: boolean;
    userService: UserServiceModal;

    isModalOpen = false;
    constructor(public dialog: MatDialog, public notificationService: NotificationService, public user: UserService, public apiService: RestApiService, public utilityService: UtilityService, public companyService: CompanyService, public configService: ConfigService) {
        this.userService = user.userServiceModal;
    }

    public getPaymentType(checkFlow: boolean = false): Promise<Array<any>> {
        return new Promise((resolve, reject) => {
            const request = {
                countrycode: this.configService.commonData.selectedCountry || 'us',
            };
    
            const getPaymentTypePromise = this.apiService.getPaymentMerchants(request).toPromise()
                .then((result) => {
                    if (result && parseInt(result.Status, 10) === 0) {
                        if (result.Data && Array.isArray(result.Data)) {
                            this.PaymentTypeResponse['AllowedMethods'] = new UniquePipe().transform(result.Data, 'MerchantId');
                        } else {
                            this.PaymentTypeResponse['AllowedMethods'] = [];
                        }
                    } else {
                        const errorMsg = result?.Message || 'Unknown error from payment merchants API';
                        this.notificationService.error('error_', errorMsg);
                        throw new Error(errorMsg);
                    }
                })
                .catch((error) => {
                    throw new Error('API call failed: ' + (error.message || error));
                });

            const promises: Promise<any>[] = [getPaymentTypePromise];

            if(!checkFlow){
                const customerId = this.userService.customerData?.CustomerId || this.PaymentDataResponse?.customerId;
                
                if (customerId) {
                    const getCustomerSavedPaymentMethodPromise = this.apiService.getCustomerSavedPaymentMethods({
                        customerId: customerId
                    }).toPromise().then((result) => {
                        if (result && parseInt(result.Status, 10) === 0) {
                            if (result.Data && Array.isArray(result.Data)) {
                                this.PaymentTypeResponse['SaveMethods'] = new UniquePipe().transform(result.Data, 'PaymentMethodId');
                                this.userService.paymentMethods = this.PaymentTypeResponse['SaveMethods'];
                                
                                // Normalize the payment method dates to ensure consistency
                                this.userService.paymentMethods = this.userService.paymentMethods.map(method => {
                                    if (method.Expires) {
                                        // Ensure the Expires date is properly formatted
                                        const expiresDate = new Date(method.Expires);
                                        if (!isNaN(expiresDate.getTime())) {
                                            // Use UTC methods to avoid timezone issues
                                            const utcMonth = expiresDate.getUTCMonth() + 1;
                                            const utcYear = expiresDate.getUTCFullYear();
                                            
                                            // Create a new UTC date to ensure consistency
                                            method.Expires = new Date(Date.UTC(utcYear, utcMonth - 1, 1));
                                            method.ExpireMonth = utcMonth;
                                            method.ExpireYear = utcYear;
                                        }
                                    }
                                    return method;
                                });
                                
                                localStorage.setItem("userService", JSON.stringify(this.userService));
                            } else {
                                this.PaymentTypeResponse['SaveMethods'] = [];
                                this.userService.paymentMethods = [];
                            }
                        } else {
                            const errorMsg = result?.Message || 'Unknown error from saved payment methods API';
                            // Don't throw error for saved methods, just log it
                            this.PaymentTypeResponse['SaveMethods'] = [];
                            this.userService.paymentMethods = [];
                        }
                    }).catch((error) => {
                        // Don't throw error for saved methods, just set empty array
                        this.PaymentTypeResponse['SaveMethods'] = [];
                        this.userService.paymentMethods = [];
                    });
                    promises.push(getCustomerSavedPaymentMethodPromise);
                } else {
                    this.PaymentTypeResponse['SaveMethods'] = [];
                    this.userService.paymentMethods = [];
                }
            }
    
            Promise.all(promises)
            .then(() => {
                resolve(this.PaymentTypeResponse);
            })
            .catch(error => {
                reject(error);
            });
        });
    }
    

    public getPaymentData(paymentdata?: any, paymentMethod: any = '', IsApplication: boolean = false) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.role = 'dialog';
        dialogConfig.width = '720px';
        const promise = new Promise((resolve, reject) => {
            const getPaymentDataRequest = {

                countrycode: this.configService.commonData.selectedCountry || 'us',
                merchantid: paymentdata.MerchantId || 0,
                // iframeid: 'DsIframe',
                // storeid: 0,
                // CountryCode: this.configService.commonData.selectedCountry || 'us',
                // region: this.companyService.getRegionID(this.configService.commonData.selectedCountry),
                // languagecode: this.configService.commonData.selectedLanguage || 'en',
                customerId: this.userService.customerData.CustomerId?this.userService.customerData.CustomerId : ""
            };
            this.apiService.getPaymentMethodIFrame(getPaymentDataRequest)
                .subscribe((result) => {
                    try {
                        if (Number(result.Status) === 0) {
                            const paymentData = result.Data;
                            this.PaymentDataResponse = paymentData;

                            const isEwallet = paymentdata && paymentdata.MerchantId === EWALLET_MERCHANT_ID;
                            
                            if (!paymentData && !isEwallet) {
                                this.notificationService.error('error_', 'Unable to load payment form');
                                reject('Payment data is null');
                                return;
                            }

                            if (isEwallet && !paymentData) {
                                resolve(result);
                                return;
                            }

                            const iframeWidth = paymentData?.Width || '720px';
                            const iframeHeight = paymentData?.Height || '600px';
                            const iframeUrl = paymentData?.IFrameUrl || paymentData;

                            const iframe = this.dialog.open(HostedpaymentDialogComponent, {
                                data: {
                                    IFrameUrl: iframeUrl,
                                    Width: iframeWidth,
                                    Height: iframeHeight,
                                    isCheckout: true
                                },
                                panelClass: 'hosted_payment-Dialog',
                            });
                            iframe.afterClosed().subscribe(res => {
                                if (res && res !== true) {
                                    let paymentResultData = res;
                                    if (res.success && res.data) {
                                        paymentResultData = res.data;
                                    } else if (res.data && !res.success) {
                                        paymentResultData = res.data;
                                    }
                                    
                                    const newPayment: any = paymentResultData;
                                    newPayment.MerchantId = paymentdata.MerchantId;
                                    if (!IsApplication && (!localStorage.getItem('guestLogin') || localStorage.getItem('guestLogin') == 'false')) {
                                        // this.savePaymentMethod(newPayment);
                                    }
                                    else {
                                        this.getPaymentType(IsApplication);
                                    }
                                    const paymentMethods = this.userService.paymentMethods || [];
                                    const editingPaymentMethod = paymentMethod;
                                    if (editingPaymentMethod) {
                                        newPayment.CardType = this.detectCardType(newPayment.type, newPayment.lastFour);
                                        newPayment.Ending = newPayment.lastFour;
                                        newPayment.Last4 = newPayment.lastFour;
                                        newPayment.CreditCardTypeDescription = newPayment.CardType;
                                        newPayment.CreditCardNumberDisplay = '****' + newPayment.lastFour;
                                        
                                        let month = newPayment.expireMonth;
                                        let year = newPayment.expireYear;
                                        
                                        if (typeof month === 'string') {
                                            month = month.replace(/[^\d]/g, '');
                                            month = parseInt(month, 10);
                                        }
                                        
                                        if (typeof year === 'string') {
                                            year = year.replace(/[^\d]/g, '');
                                            if (year.length === 2) {
                                                year = 2000 + parseInt(year, 10);
                                            } else {
                                                year = parseInt(year, 10);
                                            }
                                        } else if (typeof year === 'number' && year < 100) {
                                            year = 2000 + year;
                                        }
                                        
                                        newPayment.ExpireMonth = month;
                                        newPayment.ExpireYear = year;
                                        
                                        if (newPayment.ExpireMonth && newPayment.ExpireYear) {
                                            const monthNum = parseInt(newPayment.ExpireMonth.toString(), 10);
                                            const yearNum = parseInt(newPayment.ExpireYear.toString(), 10);
                                            
                                            if (!isNaN(monthNum) && monthNum >= 1 && monthNum <= 12 && 
                                                !isNaN(yearNum) && yearNum >= new Date().getFullYear() && yearNum <= new Date().getFullYear() + 20) {
                                                newPayment.Expires = new Date(Date.UTC(yearNum, monthNum - 1, 1));
                                            } else {
                                                newPayment.Expires = null;
                                            }
                                        }
                                        
                                        const firstName = newPayment.billingInfo?.firstName || '';
                                        const lastName = newPayment.billingInfo?.lastName || '';
                                        const fullName = firstName && lastName ? `${firstName} ${lastName}` : (newPayment.billingInfo?.fullName || '');
                                        newPayment.NameOnAccount = fullName || newPayment.NameOnAccount || newPayment.Name || '';
                                        
                                        newPayment.Token = newPayment.token || newPayment.Token || "";
                                        newPayment.token = newPayment.token || newPayment.Token || "";
                                        
                                        if (newPayment.billingInfo) {
                                            newPayment.BillingAddress = newPayment.billingInfo.address?.address || newPayment.billingInfo.address || '';
                                            newPayment.BillingCity = newPayment.billingInfo.address?.city || '';
                                            newPayment.BillingState = newPayment.billingInfo.address?.state || '';
                                            newPayment.BillingZip = newPayment.billingInfo.address?.zip || newPayment.billingInfo.address?.postalCode || '';
                                            newPayment.BillingCountry = newPayment.billingInfo.address?.country || '';
                                        }
                                        
                                        const index = paymentMethods.findIndex(pm => pm.Token === editingPaymentMethod.Token || pm.token === editingPaymentMethod.token);
                                        if (index !== -1) {
                                            paymentMethods.splice(index, 1, newPayment);
                                        } else {
                                            paymentMethods.push(newPayment);
                                        }
                                        this.userService.paymentMethods = paymentMethods;
                                        this.selectedPaymentTypeName = newPayment.CardType + ' ' + newPayment.Ending;
                                    } else {
                                        // Clear existing payment methods and add the new one
                                        // Ensure we're not mixing payment methods from different users
                                        this.userService.paymentMethods = [];
                                        
                                        // Properly detect and set card type
                                        newPayment.CardType = this.detectCardType(newPayment.type, newPayment.lastFour);
                                        newPayment.Ending = newPayment.lastFour;
                                        newPayment.Last4 = newPayment.lastFour;
                                        
                                        // Ensure all display properties are set for the UI
                                        newPayment.CreditCardTypeDescription = newPayment.CardType;
                                        newPayment.CreditCardNumberDisplay = '****' + newPayment.lastFour;
                                        
                                        // Handle different possible formats for month and year
                                        let month = newPayment.expireMonth;
                                        let year = newPayment.expireYear;
                                        
                                        // If month/year are strings, try to parse them
                                        if (typeof month === 'string') {
                                            // Handle formats like "07", "7", "0/7", etc.
                                            month = month.replace(/[^\d]/g, ''); // Remove non-digits
                                            month = parseInt(month, 10);
                                        }
                                        
                                        if (typeof year === 'string') {
                                            // Handle formats like "26", "2026", "0/7/26", etc.
                                            year = year.replace(/[^\d]/g, ''); // Remove non-digits
                                            // If year is 2 digits, assume 20xx
                                            if (year.length === 2) {
                                                year = 2000 + parseInt(year, 10);
                                            } else {
                                                year = parseInt(year, 10);
                                            }
                                        } else if (typeof year === 'number') {
                                            // If year is a number, check if it's 2 digits and convert to 4 digits
                                            if (year < 100) {
                                                year = 2000 + year;
                                            }
                                        }
                                        
                                        newPayment.ExpireMonth = month;
                                        newPayment.ExpireYear = year;
                                        
                                        // Create Expires date from month and year with validation
                                        if (newPayment.ExpireMonth && newPayment.ExpireYear) {
                                            const monthNum = parseInt(newPayment.ExpireMonth.toString(), 10);
                                            const yearNum = parseInt(newPayment.ExpireYear.toString(), 10);
                                            
                                            // Validate month and year before creating date
                                            if (!isNaN(monthNum) && monthNum >= 1 && monthNum <= 12 && 
                                                !isNaN(yearNum) && yearNum >= new Date().getFullYear() && yearNum <= new Date().getFullYear() + 20) {
                                                // Create date using UTC to avoid timezone issues
                                                newPayment.Expires = new Date(Date.UTC(yearNum, monthNum - 1, 1));
                                            } else {
                                                newPayment.Expires = null;
                                            }
                                        }
                                        
                                        const firstName = newPayment.billingInfo?.firstName || '';
                                        const lastName = newPayment.billingInfo?.lastName || '';
                                        const fullName = firstName && lastName ? `${firstName} ${lastName}` : (newPayment.billingInfo?.fullName || '');
                                        newPayment.NameOnAccount = fullName || newPayment.NameOnAccount || newPayment.Name || '';
                                        
                                        // Ensure Token is set for both property names
                                        newPayment.Token = newPayment.token || newPayment.Token || "";
                                        newPayment.token = newPayment.token || newPayment.Token || "";
                                        newPayment.MerchantId = paymentdata.MerchantId;
                                        
                                        if (newPayment.billingInfo) {
                                            newPayment.BillingAddress = newPayment.billingInfo.address?.address || newPayment.billingInfo.address || '';
                                            newPayment.BillingCity = newPayment.billingInfo.address?.city || '';
                                            newPayment.BillingState = newPayment.billingInfo.address?.state || '';
                                            newPayment.BillingZip = newPayment.billingInfo.address?.zip || newPayment.billingInfo.address?.postalCode || '';
                                            newPayment.BillingCountry = newPayment.billingInfo.address?.country || '';
                                        }
                                        
                                        this.userService.paymentMethods.push(newPayment);
                                        this.selectedPaymentTypeName = newPayment.CardType + ' ' + newPayment.Ending;
                                    }
                                    this.userService.isPaymentChanged = true;
                                    localStorage.setItem('userService', JSON.stringify(this.userService));
                                    
                                    // Don't refresh payment methods immediately for enrollment flow
                                    // as it might clear the newly added payment method
                                    // The payment method is already properly set above
                                    
                                    resolve(result);
                                } else {
                                    // Payment dialog was closed without adding a payment method
                                    reject('Payment method was not added');
                                }
                            });
                            iframe.afterOpened().subscribe(res => {
                                this.isModalOpen = true;
                            });
                        } else {
                            this.notificationService.error('error_', result.ErrorDescription);
                            reject(result);
                        }
                    } catch (ex) {

                        this.notificationService.error('error_', 'error_occured_try_again');
                        reject(ex);
                    }
                }, (error) => {
                    reject(error);
                }, () => {

                });
        });
        return promise;
    }

    public savePaymentMethod(payment) {
        const promise = new Promise((resolve, reject) => {
            // Validate and sanitize expiration month and year
            const expireMonth = parseInt(payment.expireMonth, 10);
            const expireYear = parseInt(payment.expireYear, 10);
            
            // Validate month (1-12) and year (current year to current year + 20)
            const currentYear = new Date().getFullYear();
            if (isNaN(expireMonth) || expireMonth < 1 || expireMonth > 12) {
                reject('Invalid expiration month');
                return;
            }
            if (isNaN(expireYear) || expireYear < currentYear || expireYear > currentYear + 20) {
                reject('Invalid expiration year');
                return;
            }
            
            const request = {
                customerId: 0,
                createPaymentMethod: {
                    MerchantId: payment.MerchantId || 99,
                    PaymentToken: payment.token,
                    CardType: payment.type,
                    NameOnAccount: payment?.billingInfo?.fullName || '',
                    Ending: payment.lastFour,
                    Expires: moment({ year: expireYear, month: (expireMonth - 1), day: parseInt(moment().format('D'), 10) }).format(),
                    CurrencyCode: this.companyService.selectedCurrency.CurrencyCode
                }
            };
            this.apiService.createPaymentMethod(request).subscribe((response) => {
                const result = response.Data;
                if (response.Status.toString() !== '0') {
                    reject(response.ErrorDescription);
                    return;
                }
                this.getPaymentType();
                resolve(result);
            });
        });
        return promise;
    }

    public clearPayment() {
        this.PaymentDataResponse = {};
        this.PaymentTypeResponse = [];
        this.selectedPaymentTypeName = '';
        this.SelectedPaymentTypes = {};
        this.OldSelectedPaymentType = {};
        this.AllowedMethods = [];
        this.SaveMethods = [];
        localStorage.setItem('paymentService', JSON.stringify({}));
    }

    private detectCardType(cardType: string, lastFour: string): string {
        // If cardType is already properly set, use it
        if (cardType && (cardType.toLowerCase().includes('visa') || 
                        cardType.toLowerCase().includes('mastercard') || 
                        cardType.toLowerCase().includes('amex') || 
                        cardType.toLowerCase().includes('discover'))) {
            return cardType;
        }

        // If we have the last four digits, try to detect from the card number pattern
        if (lastFour && lastFour.length >= 4) {
            const firstDigit = lastFour.charAt(0);
            const firstTwoDigits = lastFour.substring(0, 2);
            
            // Visa: starts with 4
            if (firstDigit === '4') {
                return 'Visa';
            }
            // Mastercard: starts with 5 or 2
            else if (firstDigit === '5' || firstDigit === '2') {
                return 'MasterCard';
            }
            // American Express: starts with 34 or 37
            else if (firstTwoDigits === '34' || firstTwoDigits === '37') {
                return 'Amex';
            }
            // Discover: starts with 6
            else if (firstDigit === '6') {
                return 'Discover';
            }
        }

        // Fallback to the original type or default
        return cardType || 'Credit Card';
    }

}
